import { request } from 'axios/request';

import {
  FETCH_PACKAGE_DENIAL_REASONS_PENDING,
  FETCH_PACKAGE_DENIAL_REASONS_REJECTED,
  FETCH_PACKAGE_DENIAL_REASONS_FULFILLED,
  SET_MAIN_DENIAL_REASON,
} from 'constants/packageDenialReasons';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_PACKAGE_DENIAL_REASONS_PENDING,
});

const fulfilled = (data) => ({
  type: FETCH_PACKAGE_DENIAL_REASONS_FULFILLED,
  data,
});

const rejected = (error) => ({
  type: FETCH_PACKAGE_DENIAL_REASONS_REJECTED,
  error,
});

const _setMainDenialReason = (data) => ({
  type: SET_MAIN_DENIAL_REASON,
  data,
});

export const fetchDenialReasons = () => (dispatch) => {
  dispatch(pending());

  request({
    method: 'get',
    url: OMS.OMS.PACKAGE_DENIAL_REASONS,
    params: {
      is_active: true,
    },
  })
    .then((response) => dispatch(fulfilled(response.data)))
    .catch((error) => dispatch(rejected(error)));
};

export const setMainDenialReason = (data) => (dispatch) => {
  dispatch(_setMainDenialReason(data));
};


// WEBPACK FOOTER //
// ./src/actions/packageDenialReasons.js